// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"228":"3c2f4354","707":"381f8b96","729":"d0aade37"}[chunkId] + ".js";
};